import {
    sharedFetchStudentEnrollmentInfo,
    sharedFetchAllStudentsEnrollmentInfo,
} from '../shared/studentSummaryActions';
import ReadingEnrollmentClient from '../../clients/reading/EnrollmentClient';

const fetchStudentEnrollmentInfo = studentId =>
    sharedFetchStudentEnrollmentInfo(studentId, ReadingEnrollmentClient);

export const fetchAllStudentsEnrollmentInfo = (studentIds, successfulCallback) =>
    sharedFetchAllStudentsEnrollmentInfo(studentIds, ReadingEnrollmentClient, successfulCallback);

export default fetchStudentEnrollmentInfo;
